export const fmt=n=>Number(n||0).toLocaleString('en-IN');
